import { render, staticRenderFns } from "./EsacPointsProductItemsTable.vue?vue&type=template&id=58667df6&"
import script from "./EsacPointsProductItemsTable.vue?vue&type=script&lang=js&"
export * from "./EsacPointsProductItemsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports